export default __webpack_public_path__ + "static/loader-ff9fe583cf4385a755bc54fff6d448a3.svg";